import styled from 'styled-components';

const CarouselEmpty = styled.div`
  font-size: 18px;
  margin-bottom: 40px;
  padding-left: 20px;

  @media ( min-width: 768px ) {
    padding-left: 65px;
  }
`;

export default CarouselEmpty;
